<section class="diagnosis-section">
  @if (pharmacotherapies.length > 0 && !isLoading) {
    <div class="table-container">
      <table
        mat-table
        [dataSource]="pharmacotherapies"
        class="pharmacotherapy-table"
      >
        <!-- Active Principles Column -->
        <ng-container matColumnDef="active_principles">
          <th mat-header-cell *matHeaderCellDef>Principi Attivi</th>
          <td mat-cell *matCellDef="let pharmacotherapy">
            {{ pharmacotherapy.active_principle }}
          </td>
        </ng-container>
        <!-- Description Column -->
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef>Descrizione</th>
          <td mat-cell *matCellDef="let pharmacotherapy">
            {{ pharmacotherapy.description }}
          </td>
        </ng-container>
        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let pharmacotherapy">
            <button
              mat-icon-button
              [matMenuTriggerFor]="menu"
              class="action-button"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button
                mat-menu-item
                (click)="handleMenuAction('edit', pharmacotherapy)"
              >
                <mat-icon>edit</mat-icon>
                <span>Modifica</span>
              </button>
              <button
                mat-menu-item
                (click)="handleMenuAction('delete', pharmacotherapy)"
              >
                <mat-icon>delete</mat-icon>
                <span>Elimina</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  }

  @if (isLoading) {
    <div class="loading-container">
      <app-loader [size]="'big'"></app-loader>
    </div>
  }

  @if (pharmacotherapies.length === 0 && !isLoading) {
    <div class="no-pharmacotherapies">
      <img
        src="assets/imgs/undraw/undraw_waiting_for_you.svg"
        alt="Nessuna farmacoterapia"
      />
      <span>Nessuna farmacoterapia disponibile</span>
    </div>
  }
</section>

<!-- modify pharmacotherapy panel -->
@if (showModifyPharmacotherapyPanel) {
  <app-panel-with-checkbox-list
    [title]="'edit_pharmacotherapy'"
    [patientId]="patientId"
    [activePrinciplesList]="editActivePrinciplesObj"
    [pharmacotherapyDescription]="pharmacotherapyDescription"
    (toggleActivePrinciples)="toggleModifyPanel()"
    (confirm)="confirmModifyPharmacotherapy($event)"
  ></app-panel-with-checkbox-list>
}

<!-- add pharmacoterapy panel -->
@if (showActivePrinciplesPanel) {
  <app-panel-with-checkbox-list
    [title]="'new_pharmacotherapy'"
    [patientId]="patientId"
    [activePrinciplesList]="newActivePrinciplesObj"
    (toggleActivePrinciples)="toggleActivePrinciplesPanel()"
    (confirm)="confirmNewPharmacotherapy($event)"
  ></app-panel-with-checkbox-list>
}
